// extracted by mini-css-extract-plugin
export default {"container":"rZ-z","title":"sZ-z","link":"tZ-z"};